import React from "react"
import { ui } from "../../../shared/styles/uiSystem"

export function HighlightRow({ label, value }) {
  return (
    <div
      style={{
        ...ui.softCard,
        padding: 12,
        marginBottom: 8
      }}
    >
      <div
        style={{
          fontSize: 11,
          color: "#64748b",
          marginBottom: 4
        }}
      >
        {label}
      </div>
      <div style={{ fontWeight: 900, color: "#0f172a" }}>{value}</div>
    </div>
  )
}

export function MetricChip({ label, value }) {
  return (
    <div
      style={{
        ...ui.softCard,
        padding: 10
      }}
    >
      <div
        style={{
          fontSize: 11,
          color: "#64748b",
          marginBottom: 4
        }}
      >
        {label}
      </div>
      <div style={{ fontWeight: 900, color: "#0f172a" }}>{value}</div>
    </div>
  )
}

export function InsightMiniCard({ label, value }) {
  return (
    <div
      style={{
        ...ui.softCard,
        padding: 12
      }}
    >
      <div
        style={{
          fontSize: 11,
          color: "#64748b",
          marginBottom: 4
        }}
      >
        {label}
      </div>
      <div style={{ fontWeight: 900, color: "#0f172a" }}>{value}</div>
    </div>
  )
}

export function Tag({ children }) {
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        minHeight: 24,
        padding: "0 8px",
        borderRadius: 999,
        background: "#f8fafc",
        border: "1px solid #e2e8f0",
        color: "#334155",
        fontSize: 10,
        fontWeight: 800
      }}
    >
      {children}
    </span>
  )
}

export function EmptyState({ loading, text }) {
  return (
    <div style={{ color: "#64748b", fontSize: 13 }}>
      {loading ? "Cargando..." : text}
    </div>
  )
}

export function CollapseButton({ collapsed, onClick }) {
  return (
    <button
      onClick={onClick}
      style={{
        ...ui.secondaryButton,
        minWidth: 42,
        minHeight: 36
      }}
    >
      {collapsed ? "+" : "−"}
    </button>
  )
}

export const tableCellStyle = {
  padding: "10px 8px",
  borderBottom: "1px solid #f1f5f9",
  color: "#334155",
  fontSize: 13,
  verticalAlign: "top"
}